<template>

    <div class="row">
        <div class="col-sm-5">
            <div class="imgWrapper">
                <img class="w-100 mb-3" src="/assets//images/wine.webp" width="500" />
            </div>
        </div>
        <div class="col-sm-7">
            <h3 class="mb-4 fw-bold">Yaxşı içkini necə tanımaq olar ?</h3>

            <h4 class="fw-bold mt-3 mb-2">Rəng və Təmizlik</h4>
            <p>Yaxşı içki təmiz və şəffaf olmalıdır. Hər hansı bulanıqlıq və ya çöküntü içkinin keyfiyyətinə şübhə yarada bilər.</p>

            <h4 class="fw-bold mt-3 mb-2">Qoxu</h4>
            <p>Yaxşı içkinin qoxusu xoş, balanslı və təmiz olur. Həddindən artıq spirt qoxusu içkinin keyfiyyətsiz olduğunu göstərə bilər.</p>

            <h4 class="fw-bold mt-3 mb-2">Dad Profilinə Diqqət</h4>
            <p>Keyfiyyətli içkinin dadı mürəkkəb və balanslı olur. Acı, çox şirin və ya həddindən artıq kəskin dadlar keyfiyyətsizliyi göstərə bilər.</p>

            <h4 class="fw-bold mt-3 mb-2">Tərkibi və İstehsal Metodu</h4>
            <p>Yaxşı içkilər təbii tərkiblərə və düzgün fermentasiya proseslərinə malik olurlar. Etiketdə göstərilən məlumatlara diqqət yetirmək lazımdır.</p>

            <h4 class="fw-bold mt-3 mb-2">Mənbə və İstehsalçının Reputasiyası</h4>
            <p>Tanınmış və etibarlı istehsalçılar keyfiyyətə daha çox diqqət yetirir. Bu cür markaları seçmək təhlükəsiz seçim ola bilər.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "DescriptionC",
    setup() {
        return {};
    },
}
</script>
